import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { ENVIRONMENT } from '@viso/core/data-access';
import { Environment, Response } from '@viso/core/models';
import { VendorProfile } from '@viso/web/vendor/shared/models';

@Injectable({
  providedIn: 'root',
})
export class VendorProfileService {
  constructor(
    private http: HttpClient,
    @Inject(ENVIRONMENT) private environment: Environment
  ) {}

  updateProfile(vendor: VendorProfile) {
    return this.http.post<Response<VendorProfile>>(
      `${this.environment.API_URL}/vendor/profile`,
      vendor
    );
  }

  removeCoverImage() {
    return this.http.delete<Response<VendorProfile>>(
      `${this.environment.API_URL}/vendor/remove-cover`
    );
  }

  getVendorProfile() {
    return this.http.get<Response<VendorProfile>>(
      `${this.environment.API_URL}/vendor/profile`
    );
  }
}
